import { lazy, Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router';

const SellPage = lazy(() => import('./pages/pos-sell-page').then((m) => ({ default: m.PosSellPage })));
const AdminPage = lazy(() => import('./pages/pos-admin-page').then((m) => ({ default: m.PosAdminPage })));

const Fallback = () => (
  <div role="status" aria-label="Carregando" className="flex flex-col gap-3">
    {Array.from({ length: 4 }, (_, i) => (
      <div key={i} aria-hidden className="skeleton h-10 w-full" />
    ))}
  </div>
);

/** Montado em `pdv/*`: tela de vendas do balcão e gestão (histórico, caixas, devoluções, relatórios). */
export function PosRoutes() {
  return (
    <Suspense fallback={<Fallback />}>
      <Routes>
        <Route index element={<SellPage />} />
        <Route path="gestao" element={<AdminPage />} />
        <Route path="*" element={<Navigate to="." replace />} />
      </Routes>
    </Suspense>
  );
}
